import React from "react";


const PrivacyPolicy: React.FC = () => (
  <div className="font-sans antialiased text-gray-800 bg-gradient-to-br from-gray-100 to-gray-300 min-h-screen">
    {/* Header */}
    <div className="py-12 bg-gradient-to-br from-gray-100 to-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">Politique de confidentialité</h1>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">Dernière mise à jour : 23 septembre 2025</p>
        </div>
      </div>
    </div>

    {/* Content */}
    <div className="prose max-w-4xl mx-auto">
      <h2 className="text-2xl font-semibold mt-8 mb-2">Aucune collecte de données</h2>
      <p>PanierClair ne collecte, ne stocke ni n'utilise aucune donnée personnelle ou information liée à vos courses. Il n'y a pas de création de compte, aucune inscription, et aucune donnée n'est enregistrée ou analysée.</p>

      <h2 className="text-2xl font-semibold mt-8 mb-2">Respect de la vie privée</h2>
      <p>Votre vie privée est totalement respectée. Aucune information n'est transmise à des tiers, et aucune amélioration du service n'est réalisée à partir de données utilisateurs, car nous n'en collectons aucune.</p>

      <h2 className="text-2xl font-semibold mt-8 mb-2">Contact</h2>
      <p>Pour toute question concernant la confidentialité, vous pouvez nous contacter à l'adresse suivante : <a href="mailto:contact@panierclair.fr" className="text-green-600 hover:underline">contact@panierclair.fr</a></p>

      <hr />
      <p className="font-bold mt-8">En utilisant PanierClair, vous reconnaissez avoir lu et accepté cette Politique de confidentialité.</p>
    </div>
    <div className="h-12" />
  </div>
);

export default PrivacyPolicy;
